import type { CSSProperties, ReactElement } from 'react';

import Tick from '../../Icons/Tick';
import inputClasses from '../Inputs.module.css';

type Gender = 'Male' | 'Female' | 'Other';

type Props = {
    label?: string | ReactElement;
    disabled?: boolean;
    marginTop?: CSSProperties['marginTop'];
    selected?: Gender | string;
    select: (gender: Gender) => void;
};

const GenderInput = (props: Props) => (
    <div
        className={`${inputClasses.inputGroup} ${props.disabled ? inputClasses.disabled : ''}`}
        style={{ marginTop: props.marginTop ? props.marginTop : '' }}
    >
        {props.label && <label>{props.label}</label>}
        <div className={inputClasses.genderGroup}>
            <button
                className={props.selected === 'Male' ? inputClasses.genderSelected : ''}
                onClick={() => props.select('Male')}
                disabled={props.disabled}
                type="button"
            >
                <Tick visible={props.selected === 'Male'} size="16px" fill="none" />
                <span>Male</span>
            </button>
            <button
                className={props.selected === 'Female' ? inputClasses.genderSelected : ''}
                onClick={() => props.select('Female')}
                disabled={props.disabled}
                type="button"
            >
                <Tick visible={props.selected === 'Female'} size="16px" fill="none" />
                <span>Female</span>
            </button>
            <button
                className={props.selected === 'Other' ? inputClasses.genderSelected : ''}
                onClick={() => props.select('Other')}
                disabled={props.disabled}
                type="button"
            >
                <Tick visible={props.selected === 'Other'} size={16} fill="none" />
                <span>Other</span>
            </button>
        </div>
    </div>
);

export default GenderInput;
